import React from 'react';
import everfiLogo from '../../images/everfi_logo.svg.js';
import everfiLogoFIT from '../../images/everfi_logo_FIT.svg.js';
import { AttentionGrabber } from '../attention-grabber/component.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';
var TopLeftMenu = function TopLeftMenu(_ref) {
  var customLeft = _ref.customLeft,
    isDashiFi = _ref.isDashiFi,
    isEverfiAdmin = _ref.isEverfiAdmin,
    isImpersonating = _ref.isImpersonating,
    isMobile = _ref.isMobile,
    isNextAdmin = _ref.isNextAdmin,
    isUnauthenticated = _ref.isUnauthenticated,
    logoOverrideHyperlink = _ref.logoOverrideHyperlink,
    logoOverrideUrl = _ref.logoOverrideUrl,
    organization = _ref.organization;
  var nonCustomHeaderLogo = function nonCustomHeaderLogo() {
    if (logoOverrideUrl) {
      // this can be anything sent in. i. e. the branding set at the program level in next
      var img = /*#__PURE__*/React.createElement("img", {
        alt: "".concat(organization === null || organization === void 0 ? void 0 : organization.name, "'s logo"),
        src: logoOverrideUrl
      });
      return logoOverrideHyperlink ? /*#__PURE__*/React.createElement("a", {
        href: logoOverrideHyperlink
      }, img) : img;
    } else if (organization !== null && organization !== void 0 && organization.logo_url) {
      // this one comes from the uploaded image at the account level branding. It has no hyperlink feature
      return /*#__PURE__*/React.createElement("img", {
        alt: "".concat(organization.name, "'s logo"),
        src: organization.logo_url
      });
    }
    return /*#__PURE__*/React.createElement("img", {
      src: everfiLogo,
      alt: "EverFi logo"
    });
  };
  var demoOrgAttentionGrabber = function demoOrgAttentionGrabber() {
    if (!(organization !== null && organization !== void 0 && organization.demo) || isMobile) return null;
    var serverSide = typeof window === 'undefined';
    if (!serverSide) return /*#__PURE__*/React.createElement(AttentionGrabber, {
      type: "info",
      label: "Demo Account",
      className: "m-l-20 f-14"
    });

    // NXT-6333: for now, we cannot render chakraUI in SSR components
    return /*#__PURE__*/React.createElement("span", {
      className: "attention-grabber attention-grabber-info m-l-20 f-14",
      style: {
        height: 24,
        fontWeight: 500,
        display: 'inline-flex',
        alignItems: 'center',
        border: '1px solid #74b2ec',
        borderRadius: 2,
        padding: '3px 7px',
        backgroundColor: '#e3effb'
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "attention-grabber-label",
      style: {
        color: '#18519f'
      }
    }, "Demo Account"));
  };
  if (isEverfiAdmin && !isUnauthenticated && !isNextAdmin) {
    var adminHeaderClasses = _formatClassName(['admin-header-logo', {
      impersonating: isImpersonating
    }]);
    return /*#__PURE__*/React.createElement("div", {
      className: adminHeaderClasses
    }, /*#__PURE__*/React.createElement("div", {
      className: "wrench-logo"
    }, /*#__PURE__*/React.createElement("img", {
      src: everfiLogoFIT,
      alt: "EverFi logo"
    })), /*#__PURE__*/React.createElement("div", {
      className: "wrench-label"
    }, "Foundry Internal Tools"));
  } else if (customLeft) {
    return /*#__PURE__*/React.createElement("div", {
      className: "navbar-brand navbar-logo float-none",
      dangerouslySetInnerHTML: {
        __html: customLeft
      }
    });
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "header-item header-logo"
    }, nonCustomHeaderLogo(), !isDashiFi && /*#__PURE__*/React.createElement("button", {
      id: "skipLink",
      className: "sr-only sr-only-focusable"
      /* @ts-ignore */,
      tabIndex: "0",
      "aria-label": "Skip to main content",
      href: "#"
    }, "Skip to main content")), demoOrgAttentionGrabber());
  }
};
TopLeftMenu.displayName = 'TopLeftMenu';
export { TopLeftMenu as default };